<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Press & Media </h1>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>


<!-- PORTFOLIO
        ================================================== -->
<!-- <section class="bg-light-color">
    <div class="container">
        <div class="section-title-02 position-relative text-center mb-2-9 wow fadeInUp" data-wow-delay="100ms">
            <span class="sm-title">Awards </span>
            <h2 class="position-relative z-index-9 mb-0 mx-auto">Lokmat Women Achievers of Mumbai 2025</h2>
        </div>

        <div class="row portfolio-gallery mt-n5">
            <div class="col-md-6 col-xl-3 mt-5 wow fadeInUp" data-wow-delay="100ms" data-src="images/portfolio/1.jpg"
                data-sub-html="<h4 class='text-white'>Lokmat Women Achievers of Mumbai 2025</h4>">
                <div class="portfolio-style01 position-relative h-100">
                    <div class="inner-box ">
                        <div class="portfolio-img overflow-hidden">
                            <img src="/assets/images/portfolio/1.jpg" alt="mandavi s mishra" />
                        </div>
                        <div class="portfolio-content p-4 text-center">
                            <h5 class="port-text d-block h4">Lokmat Women Achievers of Mumbai 2025
                            </h5>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-md-6 col-xl-3 mt-5 wow fadeInUp" data-wow-delay="150ms" data-src="images/portfolio/2.jpg"
                data-sub-html="<h4 class='text-white'>Lokmat Women Achievers of Mumbai 2025</h4>">
                <div class="portfolio-style01 position-relative h-100">
                    <div class="inner-box">
                        <div class="portfolio-img overflow-hidden">
                            <img src="/assets/images/portfolio/2.jpg" alt="mandavi s mishra" />
                        </div>
                        <div class="portfolio-content p-4 text-center">
                            <h5 class="port-text d-block h4">Lokmat Women Achievers of Mumbai 2025
                            </h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-3 mt-5 wow fadeInUp" data-wow-delay="200ms" data-src="images/portfolio/3.jpg"
                data-sub-html="<h4 class='text-white'>Lokmat Women Achievers of Mumbai 2025</h4>">
                <div class="portfolio-style01 position-relative h-100">
                    <div class="inner-box">
                        <div class="portfolio-img overflow-hidden">
                            <img src="/assets/images/portfolio/3.jpg" alt="mandavi s mishra" />
                        </div>
                        <div class="portfolio-content p-4 text-center">
                            <h5 class="port-text d-block h4">Lokmat Women Achievers of Mumbai 2025
                            </h5>

                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-3 mt-5 wow fadeInUp" data-wow-delay="1000ms" data-src="images/portfolio/5.jpg"
                data-sub-html="<h4 class='text-white'>Lokmat Women Achievers of Mumbai 2025</h4>">
                <div class="portfolio-style01 position-relative h-100">
                    <div class="inner-box">
                        <div class="portfolio-img overflow-hidden">
                            <img src="/assets/images/portfolio/5.jpg" alt="mandavi s mishra" />                          
                        </div>
                        <div class="portfolio-content p-4 text-center">
                            <h5 class="port-text d-block h4">Lokmat Women Achievers of Mumbai 2025
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->


<!-- AWARDS (dynamic, one block per award title) -->
<section class="bg-light-color" *ngIf="awardGroups.length > 0">
    <div class="container">
        <div *ngFor="let group of awardGroups; let first = first" [class.mt-5]="!first">

            <div class="section-title-02 position-relative text-center mb-2-9">
                <span class="sm-title">Awards </span>
                <h2 class="position-relative z-index-9 mb-0 mx-auto">{{ group.title }}</h2>
            </div>

            <div class="row portfolio-gallery mt-n5">
                <div class="col-md-6 col-xl-3 mt-5" *ngFor="let a of group.items" [attr.data-src]="awardImg(a.ImageURL)"
                    [attr.data-sub-html]="'<h4 class=\'text-white\'>' + (a.Caption || group.title) + '</h4>'">
                    <div class="portfolio-style01 position-relative h-100">
                        <div class="inner-box">
                            <div class="portfolio-img overflow-hidden">
                                <img [src]="awardImg(a.ImageURL)" [alt]="a.Caption || group.title" />
                            </div>
                            <div class="portfolio-content p-4 text-center">
                                <h5 class="port-text d-block h4">{{ a.Caption || group.title }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>


<!-- BLOG GRID
        ================================================== -->

<section class="overflow-visible bg-light-yellow2">
    <div class="container">
        <div class="section-title-04 center text-center mb-5 position-relative wow fadeInUp animated"
            data-wow-delay="100ms">
            <h2 class="lh-1 mb-0 w-sm-80 w-md-60 w-lg-45 mx-auto">Press and
                Media</h2>
            <div class="line"></div>
        </div>
        <!-- Loading State -->
        <div *ngIf="isLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading press media...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="errorMessage && !isLoading" class="alert alert-danger text-center">
            {{ errorMessage }}
            <button class="btn btn-sm btn-outline-danger ms-3" (click)="loadPressMedia()">Retry</button>
        </div>

        <!-- No Data State -->
        <div *ngIf="!isLoading && !errorMessage && pressMediaItems.length === 0" class="text-center py-5">
            <p class="text-muted">No press media articles available at the moment.</p>
        </div>

        <!-- Press Media Grid -->
        <div class="row g-xl-5 mt-n2-9" *ngIf="!isLoading && !errorMessage && pressMediaItems.length > 0">

            <!-- Loop through press media items -->
            <div class="col-md-4 col-lg-4 mt-2-9 wow fadeInUp" data-wow-delay="100ms"
                *ngFor="let item of pressMediaItems; let i = index">
                <article class="card card-style-10 bg-transparent">
                    <div class="image-box">
                        <div class="image">
                            <img [src]="'https://crm-api.redmonkwellness.com/' + item.ImageURL"
                                [alt]="item.Title ? item.Title + ' - Red Monk Wellness' : 'Red Monk Wellness wellness service'" />
                        </div>
                    </div>
                    <div class="card-body border-radius-10">
                        <ul class="list-unstyled mb-3">
                            <li class="d-inline-block me-3 text-capitalize">
                                <i class="fa fa-newspaper me-2 text-primary"></i>
                                <!-- <img src="/assets/images/press/tribuey" alt="News logo" /> -->
                                <!-- Use routerLink for internal links, href for external -->
                                <a *ngIf="isInternalLink(item.SiteURL)">{{ item.Source ||
                                    'News Source' }}</a>
                                <a *ngIf="!isInternalLink(item.SiteURL) && item.SiteURL" class="cursor-auto"
                                    target="_blank">{{ item.Source || 'News Source' }}</a>
                                <span *ngIf="!item.SiteURL">{{ item.Source || 'News Source' }}</span>
                            </li>

                            <li class="d-inline-block me-3 text-capitalize">
                                <i class="fa fa-calendar me-2 text-primary"></i>
                                <!-- Format date from backend -->
                                {{ formatDate(item.Date) || (item.CreationDate ? formatDate(item.CreationDate) : 'Date
                                not available') }}
                            </li>
                        </ul>

                        <h3 class="mb-2 h4">
                            <!-- Use routerLink for internal links, href for external -->
                            <a *ngIf="isInternalLink(item.SiteURL)" class="cursor-auto">{{ item.Title ||
                                'Untitled Article' }}</a>
                            <a *ngIf="!isInternalLink(item.SiteURL) && item.SiteURL"
                                class="cursor-auto"  target="_blank">{{ item.Title || 'Untitled Article' }}</a>
                            <span *ngIf="!item.SiteURL">{{ item.Title || 'Untitled Article' }}</span>
                        </h3>

                        <!-- Read More Link -->
                        <!-- <a *ngIf="item.SiteURL" [attr.href]="isInternalLink(item.SiteURL) ? null : item.SiteURL"
                            [routerLink]="isInternalLink(item.SiteURL) ? item.SiteURL : null"
                            [target]="isInternalLink(item.SiteURL) ? '' : '_blank'" class="read-more"
                            style="cursor: pointer;">
                            Read more <i class="fas fa-arrow-right align-middle ms-1 text-primary"></i>
                        </a> -->

                        <!-- Read More Link -->
                        <ng-container *ngIf="item.SiteURL">
                            <a *ngIf="isInternalLink(item.SiteURL)" [routerLink]="item.SiteURL" class="read-more"
                                style="cursor: pointer;">
                                Read more <i class="fas fa-arrow-right align-middle ms-1 text-primary"></i>
                            </a>
                            <a *ngIf="!isInternalLink(item.SiteURL)" [href]="item.SiteURL" target="_blank"
                                class="read-more" style="cursor: pointer;">
                                Read more <i class="fas fa-arrow-right align-middle ms-1 text-primary"></i>
                            </a>
                        </ng-container>

                        
                    </div>
                </article>
            </div>

        </div>

    </div>
</section>